module.exports = __webpack_public_path__ + "img/44.bc87e82d.jpg";